import React from "react";
import { FaArrowRight, FaCar, FaShieldAlt } from "react-icons/fa";

export type AffiliateLaunchCardProps = {
  isEn: boolean;
  onLaunch: () => void;
};

export default function AffiliateLaunchCard({
  isEn,
  onLaunch,
}: AffiliateLaunchCardProps) {
  return (
    <div className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-6 shadow-2xl shadow-slate-900/10 md:p-8">
      <div className="absolute -right-14 -top-14 h-44 w-44 rounded-full bg-cyan-100 blur-3xl" />
      <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-blue-100 blur-3xl" />

      <div className="relative">
        <div className="mb-6 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-emerald-700">
            <FaShieldAlt /> {isEn ? "Affiliate partner" : "Partenaire affilié"}
          </div>
          <span className="rounded-full bg-slate-100 px-3 py-1 text-[10px] font-bold text-slate-500">
            Forfeo Explore
          </span>
        </div>

        <div className="grid items-center gap-7 md:grid-cols-[auto_1fr]">
          <div className="flex h-24 w-24 items-center justify-center rounded-[1.75rem] bg-gradient-to-br from-cyan-500 to-blue-700 text-4xl text-white shadow-xl shadow-cyan-500/20">
            <FaCar />
          </div>

          <div>
            <p className="text-[10px] font-black uppercase tracking-[0.22em] text-cyan-700">
              {isEn
                ? "Stable partner search"
                : "Recherche partenaire optimisée"}
            </p>
            <h3 className="mt-2 text-2xl font-black tracking-tight text-slate-950 md:text-3xl">
              {isEn
                ? "Compare car rentals without date errors"
                : "Comparez les locations d’auto sans erreur de date"}
            </h3>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-base">
              {isEn
                ? "Open Forfeo Explorer Plus to choose your pickup location, dates and vehicle through the dedicated partner experience."
                : "Ouvrez Forfeo Explorer Plus pour choisir le lieu de prise en charge, les dates et le véhicule dans l’expérience partenaire dédiée."}
            </p>
          </div>
        </div>

        <div className="mt-7 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm leading-relaxed text-slate-600">
          {isEn
            ? "Final prices, availability and rental conditions are confirmed directly with the partner."
            : "Les prix finaux, disponibilités et conditions de location sont confirmés directement auprès du partenaire."}
        </div>

        <button
          type="button"
          onClick={onLaunch}
          className="mt-6 inline-flex items-center gap-3 rounded-full bg-slate-950 px-6 py-4 text-xs font-black uppercase tracking-[0.16em] text-white shadow-xl transition hover:-translate-y-1 hover:bg-cyan-700"
        >
          {isEn ? "Compare cars" : "Comparer les voitures"} <FaArrowRight />
        </button>
      </div>
    </div>
  );
}
